if (!customElements.get('product-specifications')) {
    customElements.define(
      'product-specifications',
      class ProductSpecifications extends HTMLElement {
        onVariantChangeUnsubscriber = undefined;
        selectors = {
          mainList: '[data-product-specifications-list]',
        };

        classes = {
          item: 'product-specifications__item',
          itemLabel: 'product-specifications__item-label',
          itemValue: 'product-specifications__item-value',
        };
  
        constructor() {
          super();
  
            this.mainList = this.querySelector(this.selectors.mainList);
        }
  
        connectedCallback() {
          this.onVariantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, this.handleVariantChange.bind(this));
        }
        disconnectedCallback() {
          if (onVariantChangeUnsubscriber) {
            this.onVariantChangeUnsubscriber();
          }
        }

        get allFields() {
          return JSON.parse(this.dataset.allFields);
        }

        handleVariantChange(event) {
          const variantId = event.data.variant.id.toString();
  
          const settings = window.rashbelProductSettings.variants[variantId];

          if (!settings) return;

          // Clear the list before adding new items
          this.mainList.innerHTML = '';

          let hasFields = false;

          this.allFields.forEach(fieldName => {
            
            const translation = window.rashbelTranslations.products.product.specifications[fieldName];
            let fieldValue = settings[fieldName];

            // If value is object
            if (fieldValue && typeof fieldValue === 'object') {
              // Check if empty
              if (Object.keys(fieldValue).length === 0) {
                return;
              }

              let unitTranslation = window.rashbelTranslations.products.product.units[fieldValue.unit];
              // decode the value &quot; 
              
              // Should be {value: '', unit: ''}
              fieldValue = fieldValue.value + ' ' + htmlDecode(unitTranslation || fieldValue.unit);
            }

            if (!fieldValue || !translation) return;

            const li = document.createElement('li');
            li.classList.add(this.classes.item);  

            const label = document.createElement('span');
            label.classList.add(this.classes.itemLabel);
            label.textContent = translation + ': ';

            const value = document.createElement('span');
            value.classList.add(this.classes.itemValue);
            value.textContent = fieldValue;
            li.appendChild(label);
            li.appendChild(value);
            this.mainList.appendChild(li);

            hasFields = true;
          });

          // If no fields, hide the element
          if (!hasFields) {
            this.mainList.style.display = 'none';
          } else {
            this.mainList.style.display = '';
          }
        }
      },
    );
  }
  